import { render, staticRenderFns } from "./edit-album.vue?vue&type=template&id=4544ab20&scoped=true&"
import script from "./edit-album.vue?vue&type=script&lang=js&"
export * from "./edit-album.vue?vue&type=script&lang=js&"
import style0 from "./edit-album.vue?vue&type=style&index=0&id=4544ab20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4544ab20",
  null
  
)

export default component.exports